/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CompanyNewCompany,
    CompanyNewCompanyFromJSON,
    CompanyNewCompanyToJSON,
} from '../models';

export interface NewCompanyPostRequest {
    companyNewCompany?: CompanyNewCompany;
}

/**
 * 
 */
export class LandingApi extends runtime.BaseAPI {

    /**
     * POST sin autenticacion desde landing. De la propia empresa para registrarse
     */
    async newCompanyPostRaw(requestParameters: NewCompanyPostRequest): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/new_company`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyNewCompanyToJSON(requestParameters.companyNewCompany),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * POST sin autenticacion desde landing. De la propia empresa para registrarse
     */
    async newCompanyPost(requestParameters: NewCompanyPostRequest): Promise<boolean> {
        const response = await this.newCompanyPostRaw(requestParameters);
        return await response.value();
    }

}
